<template>
  <div>
    <div v-if="!billingAddress">
      <h1 class="border-b border-blackish">
        {{ $t('checkout.billing-address') }}
      </h1>
      <div class="flex items-center w-1/2 ml-2 mt-4">
        <label class="radio flex items-center">
          <input type="radio" v-model="customerType" value="F" class="focus:bg-white">
          <span for="" class="pl-6 text-xs" :class="fontThin()">
            {{$t('userData.private')}}
          </span>
        </label>
        <label class="radio flex items-center ml-10" v-if="false">
          <input type="radio" v-model="customerType" value="P" class="focus:bg-white">
          <span for="" class="pl-6 text-xs" :class="fontThin()">
            {{$t('userData.company')}}
          </span>
        </label>
      </div>
      <address-form :isShipping="false" @has-billing="hasAddedBillingAddress($event)" />
    </div>

    <div v-else>
      <address-round-container
        :address="billingAddress"
        @delete="areYouSureToDelete($event)"
        @edit="openEditModal($event)"
        :title="$t('checkout.billing-address')"
        :checkout="true" />
      <div v-if="shippingTo==='shipping' && !selectedShippingAddress" class="mt-8 mb-4">
        <shipping-addresses-list :radioButtons="true" v-model="selectedShippingAddress" />
      </div>

      <div class="mt-8">
        <address-round-container
          v-if="shippingTo==='shipping' && selectedShippingAddress"
          :address="selectedShippingAddress"
          :title="$t('checkout.shipping-address')"
          v-on:delete="areYouSureToDelete($event)"
          v-on:edit="openEditModal($event)" />
      </div>

      <button
        v-if="selectedShippingAddress && shippingTo==='shipping'"
        class="border border-b2c-grey-400 hover:bg-b2c-red-300 hover:text-white rounded p-2 text-sm mt-4"
        @click="$emit('input', {}); selectedShippingAddress=null">
          {{$t('checkout.changeAddress')}}
      </button>
    </div>

    <modal name="edit-address" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressRoundContainer from '@/components/profile/AddressRoundContainer.vue';
import ShippingAddressesList from '@/components/profile/ShippingAddressesList.vue';
import AddressesMixin from '@/mixins/AddressesMixin';
import AddressForm from './profile/AddressForm.vue';

export default {
  props: ['value', 'shippingTo'],

  data() {
    return {
      customerType: 'F',
      selectedAddress: {},
      selectedShippingAddress: null,
    };
  },

  watch: {
    selectedAddress() {
      this.$emit('input', this.selectedAddress);
    },

    selectedShippingAddress() {
      this.selectedAddress = this.selectedShippingAddress ? this.selectedShippingAddress : this.billingAddress;
    },

    newAddress() {
      this.selectedAddress = this.newAddress;
    },

    shippingTo() {
      if (this.shippingTo === 'billing') {
        this.selectedAddress = this.billingAddress;
        this.selectedShippingAddress = null;
      }
    },
  },

  components: {
    AddressRoundContainer,
    ShippingAddressesList,
    AddressForm,
  },

  mixins: [AddressesMixin],

  computed: {
    ...mapGetters({
      authenticated: ['auth/authenticated'],
      customer: ['auth/customer'],
      billingAddress: ['auth/billingAddress'],
      newAddress: ['newAddress'],
    }),
  },

  mounted() {
    if (this.billingAddress) {
      this.selectedAddress = this.billingAddress;
    }
  },

  methods: {
    hasAddedBillingAddress() {
      this.selectedAddress = this.billingAddress;
    },
  },

};
</script>
